module.exports = __webpack_public_path__ + "img/zipcodefinder-b1559.web.app_.27bd6c03.png";